import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { DoctorService } from '../../services/doctor.service';
import { Users } from '../../classes/users.interface';
import { NgForm } from '@angular/forms';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { AuthService } from '../../authentication/auth.service';
import { CartService } from '../../services/cart.service';
import { Billing } from '../../classes/billing';
import { Shipping } from '../../classes/shipping';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MatSnackBar } from '@angular/material';


@Component({
  selector: 'app-updateprofile',
  templateUrl: './updateprofile.component.html',
  styleUrls: ['./updateprofile.component.css']
})
export class UpdateprofileComponent implements OnInit {
  action: any;
  msg: string;
  id: any;
  bio: any;
  mobile: any;
  name: any;
  users: Users[];
  manageprofileform: any;
  umobile: any;
  uname: any;
  uid: any;
  uemail: any;
  public loading = false;
  constructor(private commonService: CommonService, private doctorService: DoctorService,
    public form: FormBuilder, private authService: AuthService, private cartService: CartService,
    private snackBar: MatSnackBar, private dialogRef: MatDialogRef <UpdateprofileComponent>,  @Inject(MAT_DIALOG_DATA) public data: any ) {
   const udata = this.commonService.getUserDataLocally();
   this.uid = udata.uid;
   this.uname = udata.uname;
   this.uemail = udata.uemail;
   this.umobile = udata.umobile;

   this.id = data.id;
   this.name = data.name;
   this.mobile = data.mobile;
   this.bio = data.bio;
   
   this.manageprofileform = this.form.group({
     "name": new FormControl("",Validators.required),
     "mobile": new FormControl("",[Validators.required,Validators.minLength(10)]),
     "bio" : new FormControl("",Validators.required), 
     });
  }


  ngOnInit() {
    this.getParticularUser();
  }
  equalto(field_name): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
    let input = control.value;
    let isValid = control.root.value[field_name] === input
// Add a comment to this line
    if (!isValid){
    return { 'equalTo': {isValid} }
    } else {
    return null;
    }
    };
  }

  updateUserName() {
    this.loading = true;
    this.commonService.updateUserName(this.uid, this.data.name, this.data.mobile, this.data.bio)
    .subscribe(
      (x) => {
        this.loading = false;
        this.closeAfterEdit();
      });
  }

  getParticularUser() {
    this.commonService.getParticularUser(this.uid)
    .subscribe(
      (x: Users) => {
   /* this.name = x[0].name;
    this.mobile = x[0].mobile;
    this.bio = x[0].bio; */
      });
  }

  editUserName() {
    if ( this.data.name === this.name &&
     this.data.mobile === this.mobile && this.data.bio === this.bio ) {
      this.msg = 'Nothing to Update';
      this.openSnackBar();
      this.closewithoutEdit();
    } else {
      this.updateUserName();
      }
  }

  openSnackBar() {
    this.snackBar.open(this.msg , this.action, {
      duration: 4000,
    });
  }


  closeDialog() {
    this.dialogRef.close();
  }

 closeAfterEdit() {
  const result = 1;
  this.dialogRef.close(result);
}

closewithoutEdit() {
  const result = 0;
  this.dialogRef.close(result);
}
}
